var React = require('react');

function Paint (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.69,2.67v-2A.67.67,0,0,0,8,0H.67A.67.67,0,0,0,0,.67v2a.67.67,0,0,0,.67.67H8a.67.67,0,0,0,.67-.67Z","fill":"#e63946","key":0}),React.createElement("path",{"d":"M9.35,1.34V4a.67.67,0,0,1-.66.67H5.34A1.33,1.33,0,0,0,4,6v.67a.67.67,0,0,0-.67.67V10a.67.67,0,0,0,.67.67H5.34A.67.67,0,0,0,6,10V7.35a.67.67,0,0,0-.67-.67V6H8.69a2,2,0,0,0,2-2V2.67A1.33,1.33,0,0,0,9.35,1.34Z","key":1})]);
}

Paint.defaultProps = {"viewBox":"0 0 10.69 10.69"};

module.exports = Paint;

Paint.default = Paint;
